import React, { useEffect } from "react";
import "./App.scss";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./layout/Layout";
import { useSelector } from "react-redux";
import Notification from "./components/Notification/Notification";
import Page from "./pages/Page";
import SingleJob from "./pages/SingleJob";
import SinglePost from "./pages/SinglePost";
import NotFoundPage from "./pages/NotFoundPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "/", element: <Page slug="home" /> },
      {
        path: "/about",
        element: <Page slug="about" />,
      },
      {
        path: "/work",
        element: <Page slug="work" />,
      },
      {
        path: "/services",
        element: <Page slug="services" />,
      },
      {
        path: "/approach",
        element: <Page slug="approach" />,
      },
      {
        path: "/blog",
        element: <Page slug="blog" />,
      },
      {
        path: "/careers",
        element: <Page slug="careers" />,
      },
      {
        path: "/contact",
        element: <Page slug="contact" />,
      },
      {
        path: "/blog/posts/:postSlug/",
        element: <SinglePost slug="posts" />,
      },
      {
        path: "/service/:postSlug/",
        element: <Page slug="service" />,
      },
      {
        path: "/project/:postSlug/",
        element: <Page slug="project" />,
      },
      {
        path: "/job/:postSlug/",
        element: <SingleJob slug="job" />,
      },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);

function App() {
  const notification = useSelector((state) => state.ui.notification);

  return (
    <>
      {Object.keys(notification).length ? (
        <Notification
          status={notification.status}
          title={notification.title}
          message={notification.message}
        />
      ) : (
        ""
      )}
      <RouterProvider router={router} />
    </>
  );
}

export default App;
